module.exports = __webpack_public_path__ + "img/mouse.be5030ca.webp";